<template>
  <div class="apply_box"
       style="height:100%;">
    <div id="mescroll"
         class="mescroll noticeBox">
      <div>
        <div style="background: #fff;" v-if="this.tcProductId!=this.productId && !productName.includes('淘惠花')">
          <div v-if="[6,10].includes(orderStatus)">
            <div class="step">
              <img src="@/assets/img/afterLoan/xindai_step1.png" style="width: 100%;height: 100%;">
            </div>
            <div class="pro_detail">
              <div class="pro_item bb">
                <h1 class="h1"><span class="line"></span> 专属贷款机构</h1>
              </div>
              <div style="padding: 0.1rem 0.1rem;">
                <div class="careful" style="color: #FF514A;font-size: 0.12rem;line-height: 0.2rem;">
                  初审中，待分配机构。若初审通过，48小时内会有专业顾问通过短信和电话与您沟通，请保持电话畅通！
                </div>
              </div>
            </div>
          </div>
          <div v-if="orderStatus==20" style="padding-bottom: 0.2rem;">
            <div class="step">
              <img v-if="productName && (productName.includes('亿信') || productName.includes('亿信2'))"
                   src="@/assets/img/afterLoan/xindai_step2_yixin.png" style="width: 100%;height: 100%;">
              <img v-else-if="[153,154].includes(zybAgencyId)"
                   src="@/assets/img/afterLoan/xindai_step2_gzh.png" style="width: 100%;height: 100%;">
              <img v-else src="@/assets/img/afterLoan/xindai_step2.png" style="width: 100%;height: 100%;">
            </div>
            <div class="pro_detail"
                 v-if="productName && (productName.includes('亿信') || productName.includes('亿信2') || productName.includes('51信狐') || productName.includes('智信优选') || productName.includes('信业帮') || productName.includes('吉客有钱') || productName.includes('期贷') || productName.includes('橙易通') || productName.includes('铂银贷') || productName.includes('好汇推') || productName.includes('信易钱包') || productName.includes('拍易贷') || productName.includes('拍易贷2') || productName.includes('诺享钱包') || productName.includes('享易达') || productName.includes('微银信用') || productName.includes('微银信用2') || productName.includes('即刻分期') || productName.includes('桔柚花') || productName.includes('桔柚花2') || productName.includes('橙易通2') || productName.includes('e时贷') || productName.includes('e时贷2') || productName.includes('e时贷3') || productName.includes('易用钱包') || productName.includes('盈小钱') || productName.includes('分子借钱') || productName.includes('臻享分期') || productName.includes('臻享分期2') || productName.includes('好信借款') || productName.includes('诚易融') || productName.includes('浩瀚有借') || productName.includes('分期用') || productName.includes('小安分期') || productName.includes('云起信用') || productName.includes('安信借钱') || productName.includes('融树客')
                 || productName.includes('薪享客') || productName.includes('乐乐花') || productName.includes('美信钱包') || productName.includes('小源钱包') || productName.includes('互融智贷') || productName.includes('好用管家') || productName.includes('鑫客通') || productName.includes('中诚易借') || productName.includes('趣记花') || productName.includes('福小猫') || productName.includes('如意花')
                 || productName.includes('融安分期') || productName.includes('特惠花') || productName.includes('微好用') || productName.includes('任意花') || productName.includes('融逸花') || productName.includes('小美易融') || productName.includes('天诚分期') || productName.includes('聚汇赢') || productName.includes('川贝分期') || productName.includes('信用派') || productName.includes('乾小花') || productName.includes('惠享花')
                 || productName.includes('好鑫花') || productName.includes('借贷宝') || productName.includes('信融借') || productName.includes('乐享花') || productName.includes('融鑫花') || productName.includes('融秒贷') || productName.includes('融信用') || productName.includes('星贷') || productName.includes('诚小花')  || productName.includes('大麦花花'))">
              <div style="width: 100%;height: 8px;background: #f7f7f7;"></div>
              <div class="pro_item bb">
                <h1 class="h1"><span class="line"></span> {{ productName }}</h1>
                <div style="display: flex;" @click="agencyToast=true">
                                    <span>
                                        <img src="@/assets/img/afterLoan/tx_phone.png"
                                             style="width: 0.15rem;height: 0.15rem;margin-top: 2px;">
                                    </span>
                  <span class="txBtn">联系机构</span>
                </div>
              </div>
              <div style="padding: 0.14rem 0.14rem 0rem 0.1rem;font-size: 0.12rem;font-weight: 400;color: #2F2F2F;">
                请保持电话畅通，工作时间内一般会在当天致电复审！若您长时间未接到电话，请检查是否屏蔽来电，或 <span style="color: #486CFF;"
                                                                     v-if="phoneTxt">联系机构的客服热线：{{ phoneTxt }}</span>
              </div>
            </div>
            <div class="pro_detail" v-else>
              <div style="width: 100%;height: 8px;background: #f7f7f7;"></div>
              <div class="pro_item bb">
                <h1 class="h1"><span class="line"></span> 专属贷款机构</h1>
                <div style="display: flex;" @click="tixing" v-if="agencyType>0">
                                    <span v-if="messageContent">
                                        <img src="@/assets/img/afterLoan/tx_redDot_icon.png"
                                             style="width: 0.15rem;height: 0.15rem;margin-top: 2px;">
                                    </span>
                  <span v-else>
                                        <img src="@/assets/img/afterLoan/tx_icon.png"
                                             style="width: 0.15rem;height: 0.15rem;margin-top: 2px;">
                                    </span>
                  <!--<span class="txBtn">提醒联系</span>-->
                  <span class="txBtn">联系机构</span>
                </div>
              </div>
              <div v-if="agencyType == 0 && [153,154].includes(zybAgencyId)">
                <div style="text-align: center;margin-top: 0.2rem;padding: 0px 26px 0px 28px;">
                  <img src="@/assets/img/afterLoan/yihuihua_wx.png" style="width: 100%;height: 100%;">
                  <!--<img v-else src="@/assets/img/afterLoan/xinlihua_wx.png" style="width: 100%;height: 100%;">-->
                </div>
                <!--<div style="text-align: center;margin-top: 0.2rem;">
                    <div class="img" style="width: 1.5rem;height: 1.5rem;margin: 0px auto;">
                        <img v-if="zybAgencyId == 154" src="@/assets/img/afterLoan/yihuihua.jpg"
                             style="width: 100%;height: 100%;">
                        <img v-else src="@/assets/img/afterLoan/xinlihua.jpg" style="width: 100%;height: 100%;">
                    </div>
                    <div style="font-size: 0.18rem;font-weight: 700;margin: 0.1rem auto 0.02rem;"><span style="color: 22px;color: #EC614B;">初审通过!  </span>请截图关注公众号 “<span v-if="zybAgencyId == 154">融融花</span><span v-else>道呗</span>”</div>
                    <div style="font-size: 0.14rem;color: #527AF5;">专属客服为您办理</div>
                </div>-->
              </div>

              <div class="info" v-else>
                <div class="agencyName">{{ agencyName }}</div>
                <span v-if="agencyType>0">
                                    <div style="display: flex;justify-content: space-between;margin-bottom: 0.1rem;">
                                        <div>服务编码</div>
                                        <div style="color: #FF514A;">{{ serviceCode }}</div>
                                    </div>
                                    <div style="display: flex;justify-content: space-between;margin-bottom: 0.1rem;">
                                        <div>机构资料</div>
                                        <div style="color: #527AF5;cursor: pointer;" @click="seeAgencyInfo">去查看</div>
                                    </div>
                                    <div style="display: flex;justify-content: space-between;">
                                        <div>联系记录</div>
                                        <div style="color: #527AF5;cursor: pointer;" @click="getPhoneRecords">去查看</div>
                                    </div>
                                </span>
                <div class="notice">
                  <span>致电人员均属平台合作的第三方金融机构，请注意接听电话。接通来电时可让信贷经理提供服务编码来核实身份，服务编码请勿随意告知他人，谨防被骗！</span>
                </div>
              </div>

            </div>

          </div>
          <div v-if="orderStatus == 130" style="padding-bottom: 0.2rem;">
            <div class="step">
              <img src="@/assets/img/afterLoan/xindai_step_yihuihua.png"
                   style="width: 100%;height: 100%;">
              <!--<img v-else src="@/assets/img/afterLoan/xindai_step_xinlihua.png"
                   style="width: 100%;height: 100%;">-->
            </div>
            <div style="text-align: center;">
              <div style="text-align: center;margin-top: 0.2rem;padding: 0px 26px 0px 28px;">
                <img src="@/assets/img/afterLoan/yihuihua_wx.png" style="width: 100%;height: 100%;">
                <!--<img v-else src="@/assets/img/afterLoan/xinlihua_wx.png" style="width: 100%;height: 100%;">-->
              </div>
              <!--<div class="img" style="width: 1.5rem;height: 1.5rem;margin: 0px auto;">
                  <img v-if="gzhType == 1" src="@/assets/img/afterLoan/yihuihua.jpg"
                       style="width: 100%;height: 100%;">
                  <img v-else src="@/assets/img/afterLoan/xinlihua.jpg" style="width: 100%;height: 100%;">
              </div>
              <div style="font-size: 0.18rem;font-weight: 700;margin: 0.1rem auto 0.02rem;"><span style="color: 22px;color: #EC614B;">初审通过!  </span>请截图关注公众号 “<span v-if="gzhType == 1">融融花</span><span v-else>道呗</span>”</div>
              <div style="font-size: 0.14rem;color: #527AF5;" @click="followToast=true">专属客服为您办理</div>-->
            </div>
            <!--<div class="follow" @click="followToast=true"><span>去关注</span></div>-->

          </div>
        </div>
        <div v-else class="tcApi">
          <div v-if="binded">
            <div class="step">
              <img v-if="orderStatus == 6" src="@/assets/img/afterLoan/tcApi_step1.png">
              <img v-if="orderStatus == 10" src="@/assets/img/afterLoan/tcApi_step2.png">
              <img v-if="orderStatus == 20" src="@/assets/img/afterLoan/tcApi_step3.png">
            </div>

            <div class="result">
              <img v-if="orderStatus == 6 || orderStatus == 10"
                   src="@/assets/img/afterLoan/tcApi_result_wait.png">
              <img v-if="orderStatus == 20" src="@/assets/img/afterLoan/tcApi_result_success.png">
            </div>
            <div class="title" v-if="orderStatus == 6">等待审核中</div>
            <div class="title" v-if="orderStatus == 10">正在审核中</div>
            <div class="desc" v-if="orderStatus == 6 || orderStatus == 10" style="margin-bottom: 0.6rem;">
              预计需要12个小时，请关注短信通知
            </div>
            <div class="desc" v-if="orderStatus == 20" style="margin-bottom: 0.2rem;">恭喜初审通过，请尽快确认借款信息</div>
            <div class="btn" v-if="orderStatus == 20" @click="toOperator"><span>去操作</span></div>
          </div>
          <div v-else>
            <div class="step">
              <img src="@/assets/img/afterLoan/tcApi_step4.png">
            </div>

            <div class="result">
              <img src="@/assets/img/afterLoan/tcApi_result_addInfo.png">
            </div>
            <div class="title">资料未完善</div>
            <div class="desc" style="margin-bottom: 0.2rem;">请您完善资料，完善后才能进入审核</div>
            <div class="btn" @click="toComplete"><span>去完善</span></div>
          </div>

        </div>
        <!--  -->

        <van-popup v-model="tx" class="txlx_content">
          <div v-if="messageInfo.first">
            <div class="tx_title">提醒成功</div>
            <div class="tx_content">
              已提醒您的信贷经理尽快联系您！请注意接听尾号<span>{{ messageInfo.location }}&nbsp;&nbsp;</span><span>{{ messageInfo.phone }}&nbsp;&nbsp;</span><span>{{
                messageInfo.name
              }}</span>的来电!
              (信贷经理工作时间 工作日9:00-20:00)
            </div>
            <div class="fjx"></div>
            <div class="tx_footer" @click="tx=false">我知道了</div>
          </div>
          <div v-if="!messageInfo.first">
            <div class="tx_title">提示超限</div>
            <div class="tx_content">每位用户每天最多提醒1次,
              请注意接听尾号<span>{{ messageInfo.location }}&nbsp;&nbsp;</span><span>{{ messageInfo.phone }}&nbsp;&nbsp;</span><span>{{
                  messageInfo.name
                }}</span>的来电!
              (信贷经理工作时间 工作日9:00-20:00)
            </div>
            <div class="fjx"></div>
            <div class="tx_footer" @click="tx=false">我知道了</div>
          </div>
        </van-popup>

        <van-popup v-model="lx" class="txlx_content">
          <div>
            <div class="lx_title">{{ phoneRecords.phone }} {{ phoneRecords.name }} 近三次联系记录</div>
            <div class="lx_time">
              <ul v-if="phoneRecords.times && phoneRecords.times.length>0">
                <li v-for="(item,index) in phoneRecords.times" :key="index">
                  {{ item }}
                </li>
              </ul>
              <ul v-else>
                <li>暂无联系记录</li>
              </ul>
            </div>
            <div class="fjx"></div>
            <div class="tx_footer" @click="lx=false">我知道了</div>
          </div>
        </van-popup>

        <van-popup v-model="messageToast" round :closeable="true">
          <div class="messageBox">
            <div class="title">
              信贷经理发来消息
            </div>
            <div class="content">
              {{ messageContent }}
            </div>
            <div class="btn" @click="tixing">
              <span>回复</span>
            </div>
          </div>
        </van-popup>

        <van-popup v-model="followToast" :round="true">
          <div class="followToast">
            <div class="img">
              <img v-if="gzhType == 1" src="@/assets/img/afterLoan/yihuihua.jpg"
                   style="width: 100%;height: 100%;">
              <img v-else src="@/assets/img/afterLoan/xinlihua.jpg" style="width: 100%;height: 100%;">
            </div>
            <div class="title">扫描二维码关注</div>
            <div class="desc">关注公众号后，输入手机号和姓名按提示操作</div>
            <div class="btn" @click="followToast=false"><span>我知道了</span></div>
          </div>
        </van-popup>

        <van-popup v-model="agencyToast" class="txlx_content">
          <div>
            <div class="lx_title" style="font-size: 0.17rem;font-weight: 500;color: #333333;">机构信息</div>
            <div class="lx_time" style="font-size: 0.14rem;font-weight: 400;color: #999999;height: auto;">
              <ul v-if="applyConditions" style="text-align: left;margin: 0.2rem 0.17rem;">
                <li v-for="(item,index) in applyConditions.split('\n')" :key="index">
                  {{ item }}
                </li>
              </ul>
              <ul v-else>
                <li>暂无机构信息</li>
              </ul>
            </div>
            <div class="fjx"></div>
            <div class="tx_footer" @click="agencyToast=false">我知道了</div>
          </div>
        </van-popup>

        <div class="pro_detail"
             v-if="bigList.length > 0">
          <div class="pro_item bb">
            <h1 class="h1"><span class="line"></span> {{ bigJson.title }}</h1>
          </div>
          <div class="pro_item"
               v-for="(item, index) in bigList"
               :key="index">
            <p>{{ item.title }}</p>
            <p>{{ item.rightTitle }}</p>
          </div>
        </div>
      </div>
      <div class="pro_detail">
        <div class="pro_item bb">
          <h1 class="h1"><span class="line"></span> 特别提醒</h1>
        </div>
        <div style="padding: 0.1rem 0.1rem;">
          <div class="careful">
            1. 近期诈骗频发，<span style="color: #EC614B">平台提醒用户注意保护个人隐私</span>，不要相信以“银行卡错误”、“账户异常”、“征信差”等要求缴纳“手续费、保证金、解冻费“等，不点击陌生链接、不给陌生账户转账等，请提高安全意识，谨防诈骗。
          </div>
          <div class="careful">
            2. <span style="color: #EC614B">致电人员属于平台合作的第三方金融机构，</span>具体产品信息以审核为准！
          </div>
          <div class="careful">
            3. 如有需要请及时联系客服核实真伪，客服电话：0571-86076369
          </div>
          <div class="careful">
            4. 借贷有风险，请根据您的实际情况理性借贷，避免逾期或过度借贷。
          </div>
        </div>
      </div>
    </div>
    <Loading :isShow="loading"></Loading>
  </div>
</template>

<script>
import MeScroll from "mescroll.js";
import "mescroll.js/mescroll.min.css";
import LoanList from "@/components/loanList";
import Loading from '@/components/loading';

export default {
  components: {
    LoanList,
    MeScroll,
    Loading,
  },
  data() {
    return {
      // status: 6,
      loading: false,
      orderId: "",
      applyingTop: [], //头部状态渲染
      orderList: [], //下面列表
      orderTitleJson: {}, //列表titlejson
      bigList: [], //中间部分
      allList: [],
      advertList: [],
      agencyId: 0,
      orderStatus: 0,
      productId: 0,
      tx: false,
      messageInfo: {},
      lx: false,
      phoneRecords: {},
      agencyType: 0,
      agencyName: "",
      zybAgencyId: 0,
      xindaiPhone: "",
      timeRange: "",
      ifMember: false,
      serviceCode: "",
      tcProductId: 0,
      binded: 0,
      productName: "",
      messageToast: false,
      messageContent: "",
      followToast: false,
      applyConditions: "",
      gzhType: 0,
      agencyToast: false,
      phoneTxt: "",
    };
  },
  mounted() {
    this.orderId = this.$route.query.orderId;
    this.util.title("产品名称");
    this.getTcProductId();
    let _this = this;
    _this.mescroll = new MeScroll("mescroll", {
      //请至少在vue的mounted生命周期初始化mescroll,以确保您配置的id能够被找到
      down: {
        clearEmptyId: "noticeBox",
        empty: {
          tip: "暂无相关数据~", //提示
        },
        auto: false, //自动加载
        isBounce: false,
        callback: _this.downCallback,
      },
    });
    this.getDetails();
    this.getProductNewMessage();
  },
  methods: {
    downCallback() {
      this.getDetails();
      this.orderList = []; //重置数组
      this.bigList = [];
      this.allList = [];
      this.applyingTop = [];
      this.orderTitleJson = {};
      this.advertList = [];
      // //下拉刷新的回调
      this.mescroll.resetUpScroll();
    }, getDetails() {
      let param = {
        orderId: this.orderId,
      };
      this.loading = true;
      let _this = this;
      this.$get("/app/api/v1/order/details", param)
          .then((res) => {
            var e = res;
            if (e.code == 200) {
              this.agencyId = e.data.agencyId;
              this.orderStatus = e.data.orderStatus;
              this.productId = e.data.productId;
              this.agencyId = e.data.agencyId;
              this.agencyType = e.data.agencyType;
              this.agencyName = e.data.agencyName;
              this.zybAgencyId = e.data.zybAgencyId;
              this.xindaiPhone = e.data.xindaiPhone;
              this.timeRange = e.data.timeRange;
              this.ifMember = e.data.ifMember;
              this.serviceCode = e.data.serviceCode;
              this.productName = e.data.productName;
              this.applyConditions = e.data.applyConditions;
              if (this.applyConditions) {
                var idx = this.applyConditions.indexOf("客服电话：");
                if (idx != -1) {
                  this.phoneTxt = this.applyConditions.slice(idx).replace("客服电话：", "")
                }
              }
              var remark = e.data.remark;
              if (remark) {
                if (remark.includes("type")) {
                  var jsonRemark = JSON.parse(remark);
                  if (jsonRemark.type) {
                    this.gzhType = jsonRemark.type;
                  }
                }
              }
              _this.mescroll.endSuccess(); //无参
              _this.util.title(this.productName);
              this.loading = false;
              e.data.appOrderCells.map(function (item) {
                if (item.type == "product") {
                  _this.orderList = item.content; //产品列表
                  _this.orderTitleJson = item.head;
                } else if (item.type == "bigList") {
                  item.content.forEach(m => {
                    _this.bigList.push(m);
                  })
                  _this.bigJson = item.head;
                } else if (item.type == "applyingTop") {
                  _this.applyingTop = item.content;
                } else if (item.type == "smallList") {
                  _this.allList.push(item);
                } else if (item.type == "advert") {
                  _this.advertList = item.content;
                }
              });
              // _this.applyingTop[0].statusString = 1;
            } else {
              this.loading = false;
              _this.util.toast({msg: e.message});
            }
          })
          .catch((error) => {
          });
    }, getTcProductId() {
      this.$get("/app/api/v1/showxin/getTcProductInfo")
          .then((res) => {
            var e = res;
            if (e.code == 200) {
              var data = e.data;
              this.tcProductId = data.tcApiProductId;
              this.binded = data.binded;
            } else {

            }
          })
          .catch((error) => {
          });
    }, getProductNewMessage() {
      this.$get("/app/v1/messageRecord/productNewMessage?orderId=" + this.orderId)
          .then((res) => {
            var e = res;
            if (e.code == 200) {
              this.messageContent = e.data;
              if (this.messageContent) {
                this.messageToast = true;
              }
            } else {
              this.util.toast({msg: e.message});
            }
          })
          .catch((error) => {
          });
    }, toLoanMoney(pageUrl) {
      let param = {
        pageUrl: pageUrl,
      };
      if (pageUrl.indexOf("http") == "-1") {
        //跳到客户端页面——产品详情页面
        try {
          window.webkit.messageHandlers.toProductDetail.postMessage(param); //ios
        } catch (err) {
          window.AppJs.toProductDetail(JSON.stringify(param)); //android
        }
      } else {
        window.location.href = pageUrl;
      }
    }, statement() {
      window.location.href = "https://thread.yanhugame.com/agreement/statement.html";
    }, tixing() {
      /*this.$get('/app/v1/weixin/send/message', {orderId: this.orderId})
          .then(res => {
              if (res.code == 200) {
                  this.tx = true;
                  this.messageInfo = res.data;
              } else {
                  this.util.toast({msg: res.message})
              }
          })
          .catch(error => {
          });*/
      this.$router.push({
        path: "/mixed/messages",
        query: {
          orderId: this.orderId
        }
      });
    }, getPhoneRecords() {
      this.$get('/app/api/v1/order/phoneRecords', {orderId: this.orderId})
          .then(res => {
            if (res.code == 200) {
              this.lx = true;
              this.phoneRecords = res.data;
            } else {
              this.util.toast({msg: res.message})
            }
          })
          .catch(error => {
          });
    }, seeAgencyInfo() {
      this.$router.push({
        path: '/agency/images',
        query: {
          agencyId: this.agencyId
        }
      })
    }, toOperator() {
      if (this.productId == this.tcProductId) {
        window.location.href = "https://wechat.lylend.com/activity/route/app/Q3QZVI?media=api_xesj&openHook=1"
      } else {
        this.$get('/app/api/v1/showxin/getUrl', {orderId: this.orderId})
            .then(res => {
              if (res.code == 200) {
                window.location.href = res.data;
              } else {
                this.util.toast({msg: res.message})
              }
            })
            .catch(error => {
            });
      }
    }, toComplete() {
      this.$router.push({
        path: '/vip/shBankInfoAuth'
      })
    }
  },
};
</script>
<style scoped>

.apply_box {
  background: #f7f7f7;
}

.pro_detail {
  background: #ffffff;
  margin-top: 0.1rem;
}

.succ_bg .item {
  margin-top: -0.1rem;
  text-align: center;
}

.title {
  color: #333;
  font-size: 0.16rem;
  text-align: center;
}

.pro_item {
  padding: 0.14rem;
  color: #666;
  /* border-bottom: 1px solid #eee; */
  display: flex;
  flex: 1;
  justify-content: space-between;
}

.pro_item p {
  font-size: 0.14rem;
  color: #666;
}

.bb {
  border-bottom: 1px solid #eee;
}

.h1 {
  font-size: 0.14rem;
  color: #333;
}

.line {
  display: inline-block;
  width: 3px;
  height: 0.12rem;
  background: #486cff;
}


.foot span {
  color: #486cff;
}

.banner .ban_item {
  flex: 1;
  text-align: center;
  height: 0.95rem;
}

.banner img {
  width: 100%;
  height: 0.95rem;
}

.banner .bann_a {
  display: inline-block;
}
</style>
<style>
.ivu-steps .ivu-steps-tail > i {
  display: inline-block;
  width: 70%;
  height: 1px;
  vertical-align: top;
  background: #e8eaec;
  border-radius: 1px;
  position: relative;
  margin: 0 auto;
  margin-left: 66%;
}

.ivu-steps .ivu-steps-tail {
  width: 100%;
  padding: 0 10px;
  position: absolute;
  left: 0;
  top: 13px;
}

.ivu-steps-horizontal .ivu-steps-content {
  padding-left: 0px;
  position: relative;
  left: -8px;
  top: 3px;
}

.ivu-steps .ivu-steps-tail > i:after {
  position: absolute;
  left: 3%;
  content: '';
  background: #e8eaec;
  height: 3px;
}

.ivu-steps-item.ivu-steps-status-process .ivu-steps-tail > i {
  background: url('../../assets/img/afterLoan/bg1.png') no-repeat top center;
  background-size: 100% 100%;
  height: 3px;
}

.ivu-steps-item.ivu-steps-status-finish .ivu-steps-tail > i:after {
  background: url('../../assets/img/afterLoan/11@3x.png') no-repeat top center;
  background-size: 100% 100%;
}

.txlx_content {
  width: 295px;
  background: #FFFFFF;
  border-radius: 10px;
  text-align: center;
}

.txlx_content .tx_content {
  width: 260px;
  height: 84px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 28px;
}

.txlx_content .tx_title {
  width: 68px;
  height: 17px;
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 17px;
  margin: 20px auto;
}

.txlx_content .tx_content span {
  color: blue;
}

.txlx_content .tx_content {
  width: 260px;
  height: 84px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 28px;
  margin: 10px auto;
}

.txlx_content .fjx {
  width: 295px;
  height: 1px;
  background: #EEEEEE;
}

.txlx_content .tx_footer {
  width: 295px;
  height: 50px;
  background: #FFFFFF;
  border-radius: 10px;
  text-align: center;
  line-height: 50px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #4F8CFA;
}

.txlx_content .lx_title {
  width: 100%;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: #4F8CFA;
  margin-top: 20px;
}

.txlx_content .lx_time {
  width: 100%;
  height: 106px;
}

.txlx_content .lx_time ul li {
  margin-top: 0.06rem;
}

.step1 .title {
  font-size: 0.16rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #2F2F2F;
  margin-bottom: 0.1rem;
  text-align: left;
}

.step1 .title span {
  font-size: 0.12rem;
  background: #FFE9D4;
  padding: 1px 2px 1px 0px;
  margin-left: 5px;
  color: #FF514A;
}

.step1 .content {
  background: #F8F8F8;
  border-radius: 4px;
  padding: 0.05rem 0.1rem;
}

.step1 .content span {
  font-size: 0.1rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #2F2F2F;
}

.grey {
  font-size: 0.13rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #C1C1C1;
}

.step2 .title {
  font-size: 0.16rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #2F2F2F;
  margin-bottom: 0.1rem;
  text-align: left;
}

.step2 .content {
  background: #F8F8F8;
  border-radius: 4px;
  padding: 0.1rem 0.1rem;
}

.step2 .content .yuji {
  font-size: 0.12rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #2F2F2F;
  margin-bottom: 5px;
}

.step2 .desc {
  font-size: 0.1rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  margin-bottom: 5px;
}

.step2 .content .jinrong {
  font-size: 0.1rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #406CDA;
  background: #E4EEFA;
  margin-left: 5px;
  padding: 1px 5px;
}

.step2 .content .agencyInfo {
  width: 0.87rem;
  height: 0.2rem;
  background: #FFFFFF;
  border-radius: 0.13rem;
  border: 1px solid #EAEAEA;
  text-align: center;
}

.step2 .content .agencyInfo span {
  font-size: 0.1rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #2F2F2F;
}

.stepIcon {
  width: 0.1rem;
  height: 0.12rem;
}

.notice {
  padding: 5px;
  margin-top: 0.5rem;
  font-size: 0.1rem;
  font-weight: 400;
  color: #FF514A;
  text-align: center;
}

.tcApi .step {
  width: 90%;
  margin: 0px auto;
}

.tcApi .result {
  width: 1.09rem;
  height: 0.9rem;
  margin: 0px auto;
}

.tcApi .title {
  font-size: 0.16rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}

.tcApi .desc {
  font-size: 0.12rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  text-align: center;
  margin-top: 0.05rem;
}

.tcApi .btn {
  width: 90%;
  height: 0.5rem;
  background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
  box-shadow: 0rem 0.06rem 0.1rem 0rem #E4EEFA;
  border-radius: 0.25rem;
  line-height: 0.5rem;
  text-align: center;
  margin: 0rem auto;
  margin-bottom: 0.4rem;
}

.tcApi .btn span {
  font-size: 0.17rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
}

.tcApi img {
  width: 100%;
  height: 100%;
}

.careful {
  font-size: 0.1rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 0.25rem;
}

.pro_detail .agencyName {
  font-size: 0.16rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #2F2F2F;
  text-align: center;
  margin-top: 0.1rem;
}

.pro_detail .info {
  font-size: 0.14rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  padding: 0.14rem;
}

.pro_detail .notice {
  width: 95%;
  background: #FFF4DE;
  border-radius: 5px;
  text-align: left;
  padding: 0.14rem;
  margin: 0.1rem auto;
}

.pro_detail .notice span {
  font-size: 0.11rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FF9445;
  -webkit-background-clip: text;
}

.txBtn {
  font-size: 0.14rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #527AF5;
  margin-left: 3px;
}

.messageBox {
  width: 2.95rem;
  background: #FFFFFF;
  text-align: center;
}

.messageBox .title {
  font-size: 0.2rem;
  font-weight: 500;
  color: #424242;
  letter-spacing: 1px;
  margin: 0.3rem auto;
}

.messageBox .content {
  font-size: 0.16rem;
  font-weight: 400;
  color: #2F2F2F;
  letter-spacing: 1px;
  margin: 0rem 0.1rem 0.2rem;
}

.messageBox .btn {
  width: 90%;
  height: 0.5rem;
  background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
  border-radius: 0.25rem;
  line-height: 0.5rem;
  margin: 0.3rem auto;
}

.messageBox .btn span {
  font-size: 0.18rem;
  font-weight: 500;
  color: #FFFFFF;
}

.follow {
  width: 90%;
  height: 0.5rem;
  background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
  box-shadow: 0px 6px 10px 0px #E4EEFA;
  border-radius: 0.25rem;
  text-align: center;
  line-height: 0.5rem;
  margin: 0rem auto 0.3rem;
}

.follow span {
  font-size: 0.17rem;
  font-weight: 500;
  color: #FFFFFF;
}

.followToast {
  width: 2.65rem;
  background: #FFFFFF;
  border-radius: 0.14rem;
  text-align: center;
  padding: 0.15rem;
}

.followToast .img {
  width: 1.8rem;
  height: 1.8rem;
  margin: 0.12rem auto 0rem;
}

.followToast .title {
  font-size: 0.18rem;
  font-weight: 500;
  color: #3D3D3D;
  margin: 0.12rem auto;
}

.followToast .desc {
  font-size: 0.14rem;
  font-weight: 400;
  color: #3D3D3D;
}

.followToast .btn {
  width: 90%;
  height: 0.41rem;
  background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
  border-radius: 0.21rem;
  text-align: center;
  line-height: 0.41rem;
  margin: 0.1rem auto;
}

.followToast .btn span {
  font-size: 0.16rem;
  font-weight: 500;
  color: #FFFFFF;
}


</style>
